module.exports = __webpack_public_path__ + "img/imgd242.64817169.png";